import { Button } from "devextreme-react";
import React from "react";

export default function ButtonOKCancel(props) {
  const { onCancelClick, onOkClick } = props;

  return (
    <React.Fragment>
      <Button
        width={120}
        text="취소"
        type="normal"
        stylingMode="outlined"
        onClick={onCancelClick}
      />
      <Button
        width={120}
        text="확인"
        type="success"
        stylingMode="outlined"
        onClick={onOkClick}
      />
    </React.Fragment>
  );
}
